

// Remember to have it exactly as in database
export const Dashboard_Limit_Per_User = 2;